import AddressInfo from './AddressInfo';

export default AddressInfo;
